import React from 'react';

const Legend = () => {
  return (
    <>
      <div className='mb-4 border rounded p-3'>
        <div>
          <span className='box box-highlighted'>bex</span> -{' '}
          <span className='legend-text'>Highlight without comment</span>
        </div>
        <div>
          <span className='box box-commented'>bxe</span> -{' '}
          <span className='legend-text'>Highlight with comment</span>
        </div>
        <div>
          <span className='box box-comment-card-highlight'>bex</span> -{' '}
          <span className='legend-text'>
            Highlighted text when comment card is clicked
          </span>
        </div>
      </div>
    </>
  );
};

export default Legend;
